import { render, staticRenderFns } from "./single_page.vue?vue&type=template&id=72253c9c&scoped=true&"
import script from "./single_page.vue?vue&type=script&lang=js&"
export * from "./single_page.vue?vue&type=script&lang=js&"
import style0 from "./single_page.vue?vue&type=style&index=0&id=72253c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72253c9c",
  null
  
)

export default component.exports